<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  watch: {
    chartdata: function(val) {
      console.log("render");
      this.renderLineChart(val);
    },
  },
  methods: {
    renderLineChart(val) {
      this.renderChart(val, this.options);
    },
  },
};
</script>

<style></style>
